import {
  DISCOVER_RATES_FETCH_DATA,
  DISCOVER_RATES_ENABLE_LOADING,
  DISCOVER_RATES_DISABLE_LOADING,
  DISCOVER_RATES_FETCH_ERROR,
  DISCOVER_RATES_SET_SEARCH_FILTERS,
  DISCOVER_RATES_SET_FILTERS,
  DISCOVER_RATES_RESET_FILTERS,
  DISCOVER_RATES_SET_SORT_BY_FILTERS,
  DISCOVER_RATES_FETCH_FILTERS,
  DISCOVER_RATES_DISABLE_FILTERS_LOADING,
  DISCOVER_RATES_ENABLE_FILTERS_LOADING,
  DISCOVER_RATES_SET_GRID_PORTS,
  DISCOVER_RATES_FETCH_GRID_DATA,
  DISCOVER_RATES_SET_SEARCH_RESULTS,
  DISCOVER_RATES_SET_GRID_FILTERS_RANGE,
  DISCOVER_RATES_SET_GRID_LOADING,
  DISCOVER_RATES_RESET_PORT_LIST,
} from 'src/actions/constants';
import { v4 as uuid } from 'uuid';

const defaultState = {
  isLoading: false,
  isFiltersLoading: false,
  searchResults: [],
  priceTrendsData: [],
  searchFilters: {
    view: 'BUY',
  },
  fetchedFilters: {},
  sortByFilters: {
    sortBy: 'totalPrice',
    sortByOrder: 'ASC',
  },
  selectedFilters: {
    noOfContainers: 1,
    weight: {
      unit: 'mt',
      value: null,
    },
  },
  fetchedResultWithFilters: [],
  gridPorts: {},
  portList: [],
  gridTransitRange: {},
  gridFreightRange: {},
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case DISCOVER_RATES_ENABLE_LOADING: {
      return {
        ...state,
        isLoading: true,
        ...(action.isSearch && {
          uuid: uuid(),
        }),
      };
    }

    case DISCOVER_RATES_ENABLE_FILTERS_LOADING: {
      return {
        ...state,
        isFiltersLoading: true,
      };
    }

    case DISCOVER_RATES_SET_SEARCH_FILTERS: {
      return {
        ...state,
        searchFilters: {
          ...state.searchFilters,
          ...action.data,
        },
      };
    }

    case DISCOVER_RATES_SET_GRID_PORTS: {
      return {
        ...state,
        gridPorts: {
          ...state.gridPorts,
          ...action.data,
        },
      };
    }

    case DISCOVER_RATES_FETCH_GRID_DATA: {
      return {
        ...state,
        portList: {
          ...state.portList,
          ...action.data,
        },
      };
    }

    case DISCOVER_RATES_FETCH_FILTERS: {
      return {
        ...state,
        fetchedFilters: {
          ...state.fetchedFilters,
          ...action.data,
        },
      };
    }

    case DISCOVER_RATES_SET_FILTERS: {
      return {
        ...state,
        selectedFilters: {
          ...state.selectedFilters,
          ...action.data,
        },
        searchResults: action.searchResults,
      };
    }

    case DISCOVER_RATES_SET_GRID_FILTERS_RANGE: {
      return {
        ...state,
        gridFreightRange: action.data?.gridFreightRange || state.gridFreightRange,
        gridTransitRange: action.data?.gridTransitRange || state.gridTransitRange,
        transitDays: action.data?.transitDays || {},
        freightPrice: action.data?.freightPrice || {},
      };
    }

    case DISCOVER_RATES_SET_SORT_BY_FILTERS: {
      return {
        ...state,
        sortByFilters: {
          ...state.sortByFilters,
          ...action.data,
        },
      };
    }

    case DISCOVER_RATES_RESET_FILTERS: {
      return {
        ...state,
        selectedFilters: defaultState.selectedFilters
      };
    }

    case DISCOVER_RATES_DISABLE_LOADING: {
      return {
        ...state,
        isLoading: false,
      };
    }

    case DISCOVER_RATES_DISABLE_FILTERS_LOADING: {
      return {
        ...state,
        isFiltersLoading: false,
      };
    }

    case DISCOVER_RATES_FETCH_DATA: {
      return {
        ...state,
        errorMessage: undefined,
        searchResults: action.data?.searchResults || [],
        fetchedResultWithFilters: action.data?.searchResults || [],
        ...((action.isSearch ||
          action.fromURL ||
          action.tabChange ||
          action.customDataFromQuery) && {
          ...(!action.fromGridView && {
            transitDays: action.data?.transitDays || {},
          }),
          ffList: action.data?.ffList,
          stuffingAddressesList: action.data?.stuffingAddresses || [],
          destuffingAddressesList: action.data?.destuffingAddresses || [],
        }),
        ...((action.isSearch ||
          action.fromURL ||
          action.resetFreight ||
          action.tabChange ||
          action.customDataFromQuery) &&
          !action.fromGridView && {
            freightPrice: action.data?.freightPrice || {},
          }),
          priceTrendsData: action.data?.priceTrendsData || [],
      };
    }

    case DISCOVER_RATES_FETCH_ERROR: {
      return {
        ...state,
        errorMessage: action.data,
        searchResults: [],
      };
    }

    case DISCOVER_RATES_SET_SEARCH_RESULTS: {
      return {
        ...state,
        searchResults: action.data,
        fetchedResultWithFilters: action.data,
      };
    }

    case DISCOVER_RATES_SET_GRID_LOADING: {
      return {
        ...state,
        portList: {
          ...state.portList,
          ...action.data,
        },
      };
    }

    case DISCOVER_RATES_RESET_PORT_LIST: {
      return {
        ...state,
        portList: action.data,
      };
    }

    default:
      return state;
  }
};
